import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  public baseurl = environment.apiUrl;
  private landingApi = "api/Landing/";
  private commonApi = "api/Common/";
  private bookingApi="api/Booking/";
  constructor(private http: HttpClient) { }

  getVoyageDetailsByVesselsId(data) {
    const url = this.baseurl + this.landingApi + 'GetVoyageDetailsByShippingLineId';
    return this.http.post(url, data).pipe();
  }
  getPortsByTowCountryId(fromCountryId, toCountryId) {
    const url = this.baseurl + this.commonApi + 'GetPortsByTowCountryId' + "?fromCountryId=" + fromCountryId + '&toCountryId=' + toCountryId;
    return this, this.http.get(url).pipe();
  }
  getMasterCargoClass(){
    const url = this.baseurl + this.commonApi + 'GetMasterCargoClass';
    return this, this.http.get(url).pipe();
  }
  getMasterCargoSegments(){
    const url = this.baseurl + this.commonApi + 'GetMasterCargoSegments';
    return this, this.http.get(url).pipe();
  }

  getMasterCargoMovementStatus(){
    const url = this.baseurl + this.commonApi + 'GetMasterCargoMovementStatus';
    return this, this.http.get(url).pipe();
  }

  GetRateRequestForBooking(rateid,offeredrateId) {
    const url = this.baseurl + this.bookingApi + 'GetRateRequestForBookings' + '?raterequestid=' + rateid + '&offerdrateId='+ offeredrateId;
    return this.http.get(url).pipe();
  }

  SaveBookingDetails(data) {
    const url = this.baseurl + this.bookingApi + 'SaveBookingDetails';
    return this.http.post(url, data).pipe();
  }

  GetBookingList(data,currentpage,pagesize,searchfield,status) {
    const url = this.baseurl + this.bookingApi + 'GetBookingListbyUsers' + "?UserId=" + data
    + '&page=' +currentpage + '&pageSize=' +  pagesize + '&searchMsg='+ searchfield + '&status=' + status;
    return this.http.get(url).pipe();
  }

  CancelBooking(data) {
    const url = this.baseurl + this.bookingApi + 'CancelBooking' + "?bookingid=" + data;
    return this.http.get(url).pipe();
  }

  ConfirmedBooking(data) {
    const url = this.baseurl + this.bookingApi + 'ConfirmedBooking' + "?bookingid=" + data;
    return this.http.get(url).pipe();
  }

}
